import styled from "@emotion/styled";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 44px;
`;

export const ArticleWrapper = styled.div`
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    display: flex;
  }
`;
